import { api } from "./client";

export interface CompanyProduct {
  id: string;
  name: string;
  description: string;
  companyId: string;
  price: number;
  currency: string;
  quantity: number;
  status: string;
  createdAt: string;
  updatedAt: string;
  metadata?: Record<string, unknown>;
}

export interface CreateProductPayload {
  name: string;
  description?: string;
  price: number;
  currency?: string;
  skillKey?: string;
  metadata?: Record<string, unknown>;
}

export interface UpdateProductPayload {
  name?: string;
  description?: string;
  price?: number;
  currency?: string;
  status?: string;
  metadata?: Record<string, unknown>;
}

export const productsApi = {
  list: (companyId: string) =>
    api.get<{ companyId: string; count: number; products: CompanyProduct[] }>(
      `/companies/${encodeURIComponent(companyId)}/products`
    ),

  get: (companyId: string, productId: string) =>
    api.get<CompanyProduct>(
      `/companies/${encodeURIComponent(companyId)}/products/${encodeURIComponent(productId)}`
    ),

  create: (companyId: string, data: CreateProductPayload) =>
    api.post<CompanyProduct>(
      `/companies/${encodeURIComponent(companyId)}/products`,
      data
    ),

  update: (companyId: string, productId: string, data: UpdateProductPayload) =>
    api.patch<CompanyProduct>(
      `/companies/${encodeURIComponent(companyId)}/products/${encodeURIComponent(productId)}`,
      data
    ),

  delete: (companyId: string, productId: string) =>
    api.delete<void>(
      `/companies/${encodeURIComponent(companyId)}/products/${encodeURIComponent(productId)}`
    ),
};
